import React from "react"
import FormCheckbox from "../lib/FormCheckbox"

const InstrumentAlarmModalNotifications = ({formState, setFormState}) => {
  const handleChange = (ev) => {
    const name = ev.target.name
    const value = ev.target.checked
    setFormState({...formState, [name]: value})
  }

  return (
    <>
      <FormCheckbox
        key={'skipIssuesClearedNotification'}
        name={'skipIssuesClearedNotification'}
        label={'Don\'t send "Issues cleared" notification'}
        checked={formState.skipIssuesClearedNotification}
        onChange={handleChange}
      />
    </>
  )
}

export default InstrumentAlarmModalNotifications
